import React from 'react';
import PropTypes from 'prop-types';
import { formatGbp, PLATFORM_FEE_INFO, PROCESSING_FEE_INFO } from '../../utils/bookingPaymentFees';
import FeeInfoTooltip from './FeeInfoTooltip';
import './PaymentBreakdown.css';

const PaymentBreakdown = ({
  subtotal,
  platformFee = 0,
  processingFee = 0,
  chargeTotal,
  className = '',
  compact = false,
  showSubtotalLabel = 'Booking amount',
  totalLabel = 'Total due'
}) => {
  const total = chargeTotal ?? subtotal + platformFee + processingFee;
  const showPlatformFee = Number(platformFee) > 0;

  return (
    <div className={`payment-breakdown${className ? ` ${className}` : ''}${compact ? ' payment-breakdown--compact' : ''}`}>
      <div className="payment-breakdown__row">
        <span>{showSubtotalLabel}</span>
        <span>{formatGbp(subtotal)}</span>
      </div>
      {showPlatformFee ? (
        <div className="payment-breakdown__row">
          <span className="payment-breakdown__label">
            Occasia platform fee
            <FeeInfoTooltip text={PLATFORM_FEE_INFO} label="About Occasia platform fee" />
          </span>
          <span>{formatGbp(platformFee)}</span>
        </div>
      ) : null}
      {Number(processingFee) > 0 ? (
        <div className="payment-breakdown__row">
          <span className="payment-breakdown__label">
            Processing fee
            <FeeInfoTooltip text={PROCESSING_FEE_INFO} label="About processing fee" />
          </span>
          <span>{formatGbp(processingFee)}</span>
        </div>
      ) : null}
      <div className="payment-breakdown__row payment-breakdown__row--total">
        <span>{totalLabel}</span>
        <strong>{formatGbp(total)}</strong>
      </div>
    </div>
  );
};

PaymentBreakdown.propTypes = {
  subtotal: PropTypes.number.isRequired,
  platformFee: PropTypes.number,
  processingFee: PropTypes.number,
  chargeTotal: PropTypes.number,
  className: PropTypes.string,
  compact: PropTypes.bool,
  showSubtotalLabel: PropTypes.string,
  totalLabel: PropTypes.string
};

export default PaymentBreakdown;
